import { FC, Fragment } from 'react';
import { Chips } from '@medtronic/pecc-react-component-library-js';
import { Divider, Grid, Typography } from '@mui/material';
import { DocumentIcon } from '~/icons';
import { formatBytes } from '~/utils';
import { selectedFileItemNameStyles, selectedFileItemStyles } from './DeleteConfirmationModal/styles';
import { FileToDelete } from './DeleteConfirmationModal/types';

interface SelectedFilesTableProps {
  selectedFiles: FileToDelete[];
}

const SelectedFilesTable: FC<SelectedFilesTableProps> = ({ selectedFiles }) => {
  return (
    <Grid container rowSpacing={2} p={2}>
      <Grid size={{ xs: 9 }}>
        <Typography fontWeight={600}>File name</Typography>
      </Grid>
      <Grid size={{ xs: 3 }}>
        <Typography fontWeight={600}>Size</Typography>
      </Grid>
      <Grid size={{ xs: 12 }}>
        <Divider />
      </Grid>
      <Grid container sx={{ maxHeight: '40vh', overflowY: 'auto', width: '100%' }}>
        {selectedFiles.map(({ size, name }) => (
          <Fragment key={name}>
            <Grid size={{ xs: 9 }} sx={selectedFileItemStyles}>
              <DocumentIcon style={{ width: 24, height: 24 }} fill="#0000008C" />
              <Typography sx={selectedFileItemNameStyles}>{name}</Typography>
              <Chips
                chipsConfig={[
                  {
                    label: name.split('.').slice(-1)[0].toUpperCase(),
                  },
                ]}
              />
            </Grid>
            <Grid size={{ xs: 3 }} mt={2} height={40}>
              <Typography>{formatBytes(size || 0)}</Typography>
            </Grid>
          </Fragment>
        ))}
      </Grid>
    </Grid>
  );
};

export default SelectedFilesTable;
